import supabase from "../../../shared/database/supabase";
import { ServiceOrderLineRepository } from "../../../models/service-order-line/service-order-line.repository";
import { ServiceOrderLine } from "../model/service-order-line";

export const setServiceOrderLinePericia = async (serviceOrderLine: ServiceOrderLine) => {
    try {
        const { data, error } = await supabase.functions.invoke<ServiceOrderLineRepository>("set-service-order-line-pericia", {
            body: JSON.stringify({
                service_order_line_id: serviceOrderLine.id,
                pericia_id: serviceOrderLine.nuovautoClaimId,
                car_id: serviceOrderLine.car?.id || ""
            }),
        });

        if (error) {
            console.error("Error calling set-service-order-line-pericia:", error);
            return { data: null, error };
        }
        return { data: data, error: null };
    } catch (err) {
        console.error("Exception in setServiceOrderLinePericia:", err);
        throw err;
    }
};